module.exports = __webpack_public_path__ + "static/better_code_review-sider-45a86d8da3d7b261118828cc659b165d.png";